import PageLayout from "../UI/PageLayout";
import ContentForPage from "../../containers/ContentForPage";
import InfluencerSummaryPageDropdowns from "./InfluencerSummaryPageDropdowns";

export default function CreativeSummaryPage() {
  return (
    <PageLayout
      title="Creative Summary"
      dropdowns={
        <InfluencerSummaryPageDropdowns></InfluencerSummaryPageDropdowns>
      }
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ContentForPage pageName={"influencer_creative_summary"} />
        </div>
      }
    />
  );
}
